export function sendGoogleAnalytics(products) {
    if (typeof window.ga === 'undefined') {
        return;
    }

    try {
        Object.keys(products).forEach((value, key) => {
            const product = products[value];

            let object = {
                'id': product.sku || product.id,
                'name': product.name,
                'variant': product.sku,
                'price': product.price,
                'brand': product.vendor,
                'category': product.category,
                'quantity': product.qty,
                'position': key + 1,
            };

            window.ga('ec:addProduct', object);
        });

        window.ga('ec:setAction', 'checkout', {
            'step': 1,
        });
        window.ga('send', 'pageview');
    } catch (ex) {
        console.error('Unable send ga data', ex);
    }
}

export function updateCartStack(items) {
    if (typeof window.cartstack_updatecart === "function") {
        let itemActions = [];

        itemActions.push(['removeCartItems', 1]);
        items.forEach(function (item) {
            itemActions.push(['setCartItem', {
                'quantity': item.qty,
                'productID': item.sku,
                'productName': item.name,
                'productDescription': '',
                'productURL': item.options.permalink,
                'productImageURL': item.options.image,
                'productPrice': item.price
            }]);
        });

        window.cartstack_updatecart(itemActions);
    }
}
